export default __webpack_public_path__ + "ce2c2621292cd42e00191cae082a8d38.png";